document.addEventListener("DOMContentLoaded", function () {

    const header = document.querySelector('header');
    const toggleBtn = document.querySelector('.header__toggle');
    const mainNav = document.querySelector('.header__nav');

    window.onload = function () {
        // setTimeout(function () {
        header.style.opacity = 1;
        // }, 200);
    }

    // toggle mainMenu
    toggleBtn.onclick = function (event) {
        toggleBtn.classList.toggle('active');
        mainNav.classList.toggle('active');
        header.classList.toggle('active');
    }

    let prevScrollPos = window.pageYOffset;

    window.onscroll = function () {
        if (window.innerWidth > 991) {  // Check if window width is above 1200px
            if (window.scrollY > 100) {
                header.classList.add('bg-darkest-teal');
                const currentScrollPos = window.pageYOffset;

                if (prevScrollPos > currentScrollPos) {
                    header.classList.remove('hide-nav');
                } else {
                    header.classList.add('hide-nav');
                }

                prevScrollPos = currentScrollPos;
            } else {
                header.classList.remove('bg-darkest-teal');
            }
        }
    };

    function handleLogoCopy() {
        const headerWrapper = document.querySelector('.header__wrapper');
        const originalLogo = document.querySelector('.header__logo');

        if (window.innerWidth < 992) {
            if (!headerWrapper.querySelector('.cloned-logo')) {
                // Clone the logo and add a class 'cloned-logo' to prevent duplicates
                const clonedLogo = originalLogo.cloneNode(true);
                clonedLogo.classList.add('cloned-logo');
                headerWrapper.insertAdjacentElement('afterbegin', clonedLogo);
            }
        } else {
            const clonedLogo = headerWrapper.querySelector('.cloned-logo');
            if (clonedLogo) {
                clonedLogo.remove(); // Remove the cloned logo when window width is greater than 992
            }
        }
    }

    // Run on both load and resize events
    window.addEventListener('resize', handleLogoCopy);
    window.addEventListener('load', handleLogoCopy);

    // active link
    // Get the current page URL and remove trailing slash if it exists
    let currentUrl = window.location.pathname.replace(/\/$/, "");

    // Get all the navigation links
    const navLinks = document.querySelectorAll('.header__nav ul li a');

    // Loop through each link and compare with the current URL
    navLinks.forEach(link => {
        // Get the link's href and remove trailing slash if it exists
        let linkUrl = link.getAttribute('href').replace(/\/$/, "");

        // Add the 'active' class to the matching link
        if (linkUrl === currentUrl) {
            link.classList.add('active');
        }
    });

});